import {css} from "@panda/css";

import {ChevronLeftIcon} from "@pg-design/icons-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS, REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {REGISTRATION_WIZARD_STEP_COUNT} from "../../constants/registration_wizard_steps";

interface IProps {
    stepIndicatorId: string;
    stepNumber: number;
    onBack: (() => void) | null;
}

export const RegistrationWizardHeader = (props: IProps) => {
    const {stepIndicatorId, stepNumber, onBack} = props;

    return (
        <ResponsiveModal.Header className={headerStyle}>
            {onBack && (
                <button type="button" aria-label="Wstecz" className={backButtonStyle} onClick={onBack} data-testid={REGISTRATION_WIZARD_TEST_IDS.BACK_BUTTON}>
                    <ChevronLeftIcon size="2.4" />
                </button>
            )}

            <div className={headerEndStyle}>
                <Text as="span" variant="body_copy_2" id={stepIndicatorId} dataTestId={REGISTRATION_WIZARD_TEST_IDS.STEP_INDICATOR}>
                    Krok {stepNumber} z {REGISTRATION_WIZARD_STEP_COUNT}
                </Text>
                <ResponsiveModal.CloseButton dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CLOSE_REGISTER_FORM_BUTTON} />
            </div>
        </ResponsiveModal.Header>
    );
};

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 2,
    px: 2,
    py: 1
});

const backButtonStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "3.2rem",
    height: "3.2rem",
    p: 0,
    border: "none",
    borderRadius: 1,
    backgroundColor: "transparent",
    cursor: "pointer"
});

const headerEndStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 2,
    ml: "auto",
    color: "var(--colors-secondary)"
});
import {css} from "@panda/css";

import {ChevronLeftIcon} from "@pg-design/icons-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS, REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {REGISTRATION_WIZARD_STEP_COUNT} from "../../constants/registration_wizard_steps";

interface IProps {
    stepIndicatorId: string;
    stepNumber: number;
    onBack: (() => void) | null;
}

export const RegistrationWizardHeader = (props: IProps) => {
    const {stepIndicatorId, stepNumber, onBack} = props;

    return (
        <ResponsiveModal.Header className={headerStyle}>
            {onBack && (
                <button type="button" aria-label="Wstecz" className={backButtonStyle} onClick={onBack} data-testid={REGISTRATION_WIZARD_TEST_IDS.BACK_BUTTON}>
                    <ChevronLeftIcon size="2.4" />
                </button>
            )}

            <div className={headerEndStyle}>
                <Text as="span" variant="body_copy_2" id={stepIndicatorId} dataTestId={REGISTRATION_WIZARD_TEST_IDS.STEP_INDICATOR}>
                    Krok {stepNumber} z {REGISTRATION_WIZARD_STEP_COUNT}
                </Text>
                <ResponsiveModal.CloseButton dataTestId={OFFER_TEST_IDS.OFFER_VIEW.CLOSE_REGISTER_FORM_BUTTON} />
            </div>
        </ResponsiveModal.Header>
    );
};

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 2,
    px: 2,
    py: 1
});

const backButtonStyle = css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "3.2rem",
    height: "3.2rem",
    p: 0,
    border: "none",
    borderRadius: 1,
    backgroundColor: "transparent",
    cursor: "pointer"
});

const headerEndStyle = css({
    display: "flex",
    alignItems: "center",
    columnGap: 2,
    ml: "auto",
    color: "var(--colors-secondary)"
});
